export default __webpack_public_path__ + "static/media/metro.7a2e211d.jpg";